module.exports = __webpack_public_path__ + "media/list3.87677386.mp4";